import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function DennywiseTravel() {
  const services = [
    {
      icon: 'ri-flight-takeoff-fill',
      title: 'Flight Ticket Booking',
      description: 'Access to competitive fares from major airlines worldwide. We help you find the best routes and prices for your business or leisure travel needs.',
      image: 'https://public.readdy.ai/ai/img_res/4ec91c4dc73019547eeeffde9f4cbbeb.jpg'
    },
    {
      icon: 'ri-hotel-fill',
      title: 'Hotel Bookings',
      description: 'Curated selection of hotels from budget-friendly to luxury accommodations. We ensure comfortable stays that match your preferences and budget.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20five%20star%20hotel%20lobby%20with%20elegant%20interior%20design%20modern%20hospitality%20premium%20accommodation%20Dubai%20style%20architecture%20golden%20accents%20and%20royal%20blue%20elements%20world%20class%20hotel%20service%20sophisticated%20atmosphere%20clean%20professional%20setting%20highlighting%20luxury%20hospitality&width=600&height=400&seq=hotel1&orientation=landscape'
    },
    {
      icon: 'ri-map-pin-user-fill',
      title: 'Tourism Packages',
      description: 'Customized tour packages featuring popular destinations, guided tours, and unique experiences. Let us plan your perfect vacation itinerary.',
      image: 'https://readdy.ai/api/search-image?query=Dubai%20tourism%20landmarks%20Burj%20Khalifa%20and%20modern%20skyline%20beautiful%20tourist%20destination%20luxury%20vacation%20experience%20iconic%20UAE%20architecture%20golden%20hour%20lighting%20travel%20and%20tourism%20concept%20world%20famous%20attractions%20premium%20holiday%20destination%20simple%20clean%20composition&width=600&height=400&seq=tourism1&orientation=landscape'
    },
    {
      icon: 'ri-ship-fill',
      title: 'Shipment and Logistics Services',
      description: 'Reliable freight forwarding, cargo handling, and logistics solutions for businesses. We ensure your goods reach their destination safely and on time.',
      image: 'https://readdy.ai/api/search-image?query=modern%20cargo%20shipping%20containers%20at%20port%20with%20logistics%20operations%20professional%20freight%20forwarding%20service%20international%20trade%20and%20shipping%20Dubai%20port%20facilities%20efficient%20supply%20chain%20management%20blue%20and%20gold%20shipping%20containers%20organized%20warehouse%20logistics%20clean%20industrial%20setting&width=600&height=400&seq=logistics1&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Afriq Travel and Logistics
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
              Your gateway to seamless global travel experiences and reliable logistics solutions
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20travel%20agency%20office%20in%20Dubai%20with%20modern%20interior%20design%20travel%20consultants%20helping%20clients%20world%20map%20on%20wall%20luxury%20travel%20planning%20atmosphere%20vibrant%20orange%20and%20deep%20navy%20blue%20brand%20colors%20contemporary%20workspace%20tourism%20brochures%20and%20destination%20photos%20welcoming%20professional%20environment%20African%20inspired%20decor%20elements&width=800&height=600&seq=afriqtravel2&orientation=landscape"
                alt="Afriq Travel Office"
                className="w-full h-full object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">World-Class Travel Services</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                <strong className="text-blue-700">Afriq Travel and Logistics</strong> is your trusted partner for all travel and logistics needs. Whether you're planning a business trip, family vacation, or need reliable shipping solutions, we've got you covered.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                With years of experience in the travel industry and strong partnerships with airlines, hotels, and logistics providers worldwide, we offer competitive rates and exceptional service that makes your journey smooth and hassle-free.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Based in Dubai, UAE, we understand the unique needs of travelers and businesses in the region. Our dedicated team works around the clock to ensure your travel plans are executed flawlessly and your shipments arrive on time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive travel and logistics solutions for individuals and businesses
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              >
                <div className="h-64 overflow-hidden">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-8">
                  <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6 group-hover:bg-blue-700 transition-colors">
                    <i className={`${service.icon} text-3xl text-blue-700 group-hover:text-white transition-colors`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Our Travel Services */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Choose Afriq Travel</h2>
            <p className="text-xl text-gray-600">Your journey matters to us</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-700 to-blue-900 p-8 rounded-2xl text-white">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mb-6">
                <i className="ri-price-tag-3-fill text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Competitive Pricing</h3>
              <p className="leading-relaxed">
                Access to exclusive deals and competitive rates from our global network of partners, ensuring you get the best value for your money.
              </p>
            </div>

            <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 p-8 rounded-2xl text-black">
              <div className="w-16 h-16 flex items-center justify-center bg-black/20 rounded-full mb-6">
                <i className="ri-customer-service-2-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">24/7 Support</h3>
              <p className="leading-relaxed">
                Round-the-clock customer support to assist you with bookings, changes, or any travel emergencies, wherever you are in the world.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-700 to-blue-900 p-8 rounded-2xl text-white">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mb-6">
                <i className="ri-shield-check-fill text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Reliable & Secure</h3>
              <p className="leading-relaxed">
                Trusted booking processes and secure payment methods, with full transparency and protection for your travel investments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-800">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Ready to Start Your Journey?</h2>
          <p className="text-xl text-gray-200 mb-10">
            Contact us today for personalized travel solutions and competitive quotes
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/contact" 
              className="inline-block px-10 py-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book Now
            </Link>
            <a 
              href="https://wa.me/971569776320" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-10 py-4 bg-green-500 hover:bg-green-600 text-white font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-2xl mr-2 w-6 h-6 flex items-center justify-center"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
